/* shevron.js — shared behaviours for all pages */
(function () {
  'use strict';

  // ── NAV SCROLL ─────────────────────────────────────────────
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('nav--scrolled', window.scrollY > 64);
    }, { passive: true });
  }

  // ── MOBILE MENU ────────────────────────────────────────────
  var hamburger  = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileClose = document.getElementById('mobileClose');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── SCROLL REVEAL ──────────────────────────────────────────
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('on');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.r').forEach(function (el) {
    revealObs.observe(el);
  });

  // ── WHATSAPP FLOAT ─────────────────────────────────────────
  var waFloat = document.getElementById('waFloat');
  var heroEl  = document.querySelector('.hero, .page-hero, .cs-hero, .beg-hero');

  if (waFloat) {
    if (heroEl) {
      var waObs = new IntersectionObserver(function (entries) {
        waFloat.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0.4 });
      waObs.observe(heroEl);
    }
    setTimeout(function () { waFloat.classList.add('show'); }, 5000);
  }

  // ── PAGE TRANSITIONS ───────────────────────────────────────
  var overlay = document.getElementById('ptOverlay');
  if (overlay) {
    setTimeout(function () { overlay.classList.add('entering'); }, 60);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var h = a.getAttribute('href') || '';
      if (!h || h.startsWith('#') || h.startsWith('http') ||
          h.startsWith('mailto') || h.startsWith('tel') ||
          h.indexOf('wa.me') > -1) return;
      e.preventDefault();
      overlay.classList.remove('entering');
      overlay.classList.add('exiting');
      setTimeout(function () { window.location.href = h; }, 520);
    });
  }

  // ── HERO ENTRANCE ──────────────────────────────────────────
  var hl = document.querySelector('.hero-headline');
  var hb = document.querySelector('.hero-bottom');
  if (hl) {
    hl.style.cssText = 'opacity:0;transform:translateY(36px)';
    setTimeout(function () {
      hl.style.cssText = 'opacity:1;transform:none;transition:opacity 1.1s cubic-bezier(0.16,1,0.3,1),transform 1.1s cubic-bezier(0.16,1,0.3,1)';
    }, 150);
  }
  if (hb) {
    hb.style.cssText = 'opacity:0;transform:translateY(20px)';
    setTimeout(function () {
      hb.style.cssText = 'opacity:1;transform:none;transition:opacity 0.9s cubic-bezier(0.16,1,0.3,1) 0.2s,transform 0.9s cubic-bezier(0.16,1,0.3,1) 0.2s';
    }, 380);
  }

  // ── FAQ ACCORDION ──────────────────────────────────────────
  window.tFaq = function (i) {
    var item = document.getElementById('fi' + i);
    var ans  = document.getElementById('fa' + i);
    if (!item || !ans) return;
    var open = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function (el) {
      el.classList.remove('open');
      var a = el.querySelector('.faq-a');
      if (a) a.style.maxHeight = '0';
    });
    if (!open) {
      item.classList.add('open');
      ans.style.maxHeight = ans.scrollHeight + 'px';
    }
  };

})();